import React, { Fragment } from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Table, Popup, Loader, Tab, Responsive
} from 'semantic-ui-react';
import _ from 'lodash'
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';


// import styled, { keyframes } from 'styled-components';
// import { fadeIn } from 'react-animations';
import { Link, Redirect } from 'react-router-dom';
import moment from 'moment';
import PollListTable from '../Util/PollListTable';
import PollInfo from '../AdminPoll/PollPreviewTabs/PollInfo/PollInfo';
import AdminPollPreview from '../AdminPoll/PollPreviewTabs/PollPreview/AdminPollPreview';


export default class StaffTable extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            data:this.props.staffList,
            clickedColumn:'',
            column: null,
            direction: null,
        }
    }

    handleSort = (clickedColumn) => {
        return () => {
            const {column, direction, data} = this.state;
            if (column !== clickedColumn) {
                this.setState({
                    column: clickedColumn,
                    data: _.sortBy(data, [clickedColumn]),
                    direction: 'ascending',
                })

                return
            }

            this.setState({
                data: data.reverse(),
                direction: direction === 'ascending' ? 'descending' : 'ascending',
            })
        };
    }

    render() {
        let { staffList, errMess } = this.props;
        const data = this.props.staffList;
        const { column, direction } = this.state
        return (

            <div>


                <Table celled selectable compact sortable>
                    <Table.Header>
                        <Table.Row >
                            <Table.HeaderCell
                                sorted={column === 'firstName' ? direction : null}
                                onClick={this.handleSort('firstName')}>
                                    Ime
                            </Table.HeaderCell>
                            <Table.HeaderCell
                                sorted={column === 'lastName' ? direction : null}
                                onClick={this.handleSort('lastName')}>
                                    Prezime
                            </Table.HeaderCell>
                            <Table.HeaderCell
                                sorted={column === 'numberOfCourses' ? direction : null}
                                onClick={this.handleSort('numberOfCourses')}>
                                    Broj predmeta
                            </Table.HeaderCell>
                            <Table.HeaderCell
                                sorted={column === 'averageGradeForStaff' ? direction : null}
                                onClick={this.handleSort('averageGradeForStaff')}>
                                    Prosječna ocjena
                            </Table.HeaderCell>


                            <Table.HeaderCell colSpan="1" ></Table.HeaderCell>


                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {this.state.data.map((el, index) =>
                            (<Table.Row
                                key={index}
                                onClick={(e) => {
                                    this.setState({ showResults: true });
                                }}
                            >
                                <Table.Cell verticalAlign="middle">
                                    {el.firstName}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.lastName}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" width={1}>
                                    {el.numberOfCourses}
                                </Table.Cell>
                                <Table.Cell
                                    verticalAlign="middle"
                                    warning={parseFloat(el.averageGradeForStaff).toFixed(2) >= 2 && parseFloat(el.averageGradeForStaff).toFixed(2) <= 4}
                                    positive={parseFloat(el.averageGradeForStaff).toFixed(2) > 4}
                                    negative={parseFloat(el.averageGradeForStaff).toFixed(2) < 2 && parseFloat(el.averageGradeForStaff).toFixed(2) !== '-1.00'}
                                >
                                    {isNaN(el.averageGradeForStaff) ||
                                    parseFloat(el.averageGradeForStaff).toFixed(2) === 'NaN' ||
                                    JSON.stringify(el.averageGradeForStaff) === 'NaN' ||
                                    parseFloat(el.averageGradeForStaff).toFixed(2) === '-1.00'
                                        ? '-' : parseFloat(el.averageGradeForStaff).toFixed(2)}
                                </Table.Cell>
                                <Table.Cell
                                    verticalAlign="middle"
                                    textAlign="center"
                                    colSpan="1"
                                >
                                    {/* link */}
                                    <Link
                                        onClick={e => { el.numberOfCourses === 0 ? e.preventDefault() : () => {}; }}
                                        to={{
                                            pathname: '/ankete/osoblje/predmeti',
                                        }}
                                    >
                                        <Button
                                            onClick={() => {
                                                localStorage.setItem('organizationalUnitEmployeeId', el.organizationalUnitEmployeeId);
                                                localStorage.setItem('staffName', el.firstName + ' ' + el.lastName);
                                            }}
                                            disabled={el.numberOfCourses === 0}

                                            basic="true"
                                            color="blue"
                                            size="small"
                                        > Predmeti
                                        </Button>

                                    </Link>


                                </Table.Cell>
                            </Table.Row>))}
                    </Table.Body>
                </Table>


            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Poll/Util/StaffTable.js